import { render, staticRenderFns } from "./CanvasItem.vue?vue&type=template&id=667b34be&scoped=true"
import script from "./CanvasItem.vue?vue&type=script&lang=js"
export * from "./CanvasItem.vue?vue&type=script&lang=js"
import style0 from "./CanvasItem.vue?vue&type=style&index=0&id=667b34be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667b34be",
  null
  
)

export default component.exports